import { useState } from 'react'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import makeStyles from '@mui/styles/makeStyles'
import { colors } from '@global/constants'
import { DiffMessage } from './DiffMessage'
import { DiffUser } from './DiffUser'
import { t } from '@lingui/core/macro'

const useStyles = makeStyles(() => ({
  headerWrapper: {
    background: colors.gray.light,
    padding: '8px 16px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  headerTitle: {
    flex: 1,
    fontSize: 14,
    fontWeight: 'bold',
  },
  diffWrapper: {
    padding: 16,
    fontSize: 12,
  },
}))

export function CellHistory({ cellHistory }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const diff = cellHistory && cellHistory.entries ? cellHistory.entries[activeIndex] : null
  const maxIndex = cellHistory && cellHistory.entries ? cellHistory.entries.length - 1 : 0
  const isLast = activeIndex === maxIndex
  const isFirst = activeIndex === 0

  const previousEntry = () => {
    setActiveIndex(activeIndex + 1)
  }

  const nextEntry = () => {
    setActiveIndex(activeIndex - 1)
  }

  const classes = useStyles()

  return (
    <div>
      <div className={classes.headerWrapper}>
        <div className={classes.header}>
          <div className={classes.headerTitle}>{t`Cell history`}</div>
          <IconButton disabled={isLast} onClick={previousEntry} size="small">
            <ChevronLeft />
          </IconButton>
          <IconButton disabled={isFirst} onClick={nextEntry} size="small">
            <ChevronRight />
          </IconButton>
        </div>
      </div>

      <div className={classes.diffWrapper}>
        <DiffMessage diff={diff} />
        <DiffUser diff={diff} />
      </div>
    </div>
  )
}
